import { redirect } from "@tanstack/react-router";

import { supabase } from "@vendor/supabase";

export async function requireSignedIn(): Promise<void> {
  const { data } = await supabase.auth.getSession();
  if (!data.session) {
    throw redirect({ to: "/login" });
  }
}

export async function requireSignedOut(): Promise<void> {
  const { data } = await supabase.auth.getSession();
  if (data.session) {
    throw redirect({ to: "/" });
  }
}
